import { useTranslation } from 'react-i18next'

import PropTypes from 'prop-types'

import { ChipInput, EmailInput, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const BillingEmail = ({ email, onChangeEmail, allowsDirectDebit, ccEmails, onChangeCcEmails, disabled }) => {
  const { t } = useTranslation()
  return (
    <Styles.Container>
      <Text type="titleM">{t('Email facturación')}</Text>
      <Text type="bodyMRegular">
        {t(
          allowsDirectDebit
            ? 'Configura la domiciliación de tus operaciones con Reveni, así como el email en el que recibirás las facturas correspondientes'
            : 'Configura el email en el que recibirás las facturas correspondientes'
        )}
      </Text>
      <EmailInput label={t('Email facturación')} onChange={onChangeEmail} value={email} disabled={disabled} />
      <ChipInput
        fullWidth
        label={t('Destinatarios en copia (Cc)')}
        helperText={t('Añade más direcciones de email separándolas por comas (,)')}
        onChange={onChangeCcEmails}
        value={ccEmails}
        disabled={disabled}
      />
    </Styles.Container>
  )
}

BillingEmail.propTypes = {
  email: PropTypes.string,
  onChangeEmail: PropTypes.func,
  newBillingEmail: PropTypes.string,
  onChangeBillingEmail: PropTypes.func,
  changingEmail: PropTypes.bool,
  validEmail: PropTypes.bool,
}

export default BillingEmail
